const HTMLSection = "main-collection-product-grid"
const PATHNAME = window.location.pathname
class Sidebar extends HTMLElement {
  constructor() {
    super()
    this.sidebarForm = this.querySelector("ul")
    this.sidebarForm.addEventListener("custom_input", this.onSubmitHandler, false)
    // window.addEventListener('resize', () => this.resize())
    // this.resize()

    // BackButton
    const onHistoryChange = () => {
      const { tags, getTags } = Sidebar.getRoute()
      const tagsList = getTags()


      this.sidebarForm.querySelectorAll('pseudo-checkbox')
        .forEach(tag => !tagsList || !tagsList.includes(tag.name) ? tag.classList.remove('checked') : tag.classList.add('checked'))
      const url = Sidebar.generateURL(tags, false)
      Sidebar.renderPage(url)
    }
    window.addEventListener('popstate', onHistoryChange)
  }

  onSubmitHandler = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const checkedTagFilters = [
      ...this.sidebarForm.querySelectorAll("pseudo-checkbox.checked"),
    ]
    const tagFilterUrl = checkedTagFilters.map((input) => input.name.trim()).join("+")

    const url = Sidebar.generateURL(tagFilterUrl)
    Sidebar.renderPage(url)
  };

  resize() {
    const inGrid = () => {
      const parent = document.querySelector('#ProductGridContainer .collection')
      parent.insertAdjacentElement('afterbegin', this)
    }
    const inDraw = () => {
      const sibling = document.querySelector('menu-drawer .mobile-facets__main > .mobile-facets__footer')
      sibling.insertAdjacentElement('beforebegin', this)
    }

    if (window.innerWidth < 750) return inDraw()
    inGrid()
  }

  static async renderPage(url) {
    // Loading
    const grid = document.querySelector('#ProductGridContainer .collection')
    const facet = document.querySelector('facet-filters-form')
    grid.classList.add("loading")
    facet.classList.add('loading')

    const cached = this.filterData[url]
    if (cached) Sidebar.render(cached)
    else await Sidebar.renderSectionFromFetch(url)

    grid.classList.remove('loading')
    facet.classList.remove('loading')
  }

  static render(html) {
    const virtualDOM = new DOMParser().parseFromString(html, "text/html")
    Sidebar.renderProductGridContainer(virtualDOM)
    Sidebar.renderPagination(virtualDOM)
    // Sidebar.renderFacets(virtualDOM)
  }

  static async renderSectionFromFetch(url) {
    const req = await fetch(url)
    const res = await req.text()
    // const html = res[HTMLSection];
    // Sidebar.filterData = [...Sidebar.filterData, { html, url }];
    // Sidebar.renderFilters(html, event);
    this.filterData[url] = res
    Sidebar.render(res)
  }

  static renderProductGridContainer(virtualDOM) {
    const current = document.getElementById("product-grid")
    const newGrid = virtualDOM.getElementById("product-grid")

    // console.log(virtualDOM)
    // const sidebar = virtualDOM.querySelector('side-bar form')
    // this.sidebarForm.innerHTML = sidebar.innerHTML

    current.replaceWith(newGrid)
  }

  static renderFacets(virtualDOM) {
    const current = document.querySelector('#FacetFiltersForm')
    const newForm = virtualDOM.querySelector('#FacetFiltersForm')
    current.innerHTML = newForm.innerHTML

    // Menú Drawer
    const drawer = document.querySelector('menu-drawer')
    const currentFilters = drawer.querySelector('menu-drawer facet-filters-form')
    const newFilters = virtualDOM.querySelector('menu-drawer facet-filters-form')

    // Re-renderear sidebar
    const sidebar = document.querySelector('side-bar')

    // currentFilters.innerHTML = newFilters.innerHTML
    currentFilters.replaceWith(newFilters)
    sidebar.resize()
    drawer.bindEvents()
  }

  static renderPagination(virtualDOM) {
    const current = document.querySelector('.pagination-wrapper')
    if (!current) return
    const newPagination = virtualDOM.querySelector('.pagination-wrapper')
    if (newPagination) {
      current.replaceWith(newPagination)
      current.style.display = 'block'
    } else {
      current.style.display = 'none'
    }
  }

  static getRoute() {
    const uri = new URL(location.href)

    uri.searchParams.set('page', '1')

    const search = uri.search

    const parts = uri.pathname.split("/")
    const collection = parts[2]
    const tags = parts[3] || ""
    const getTags = () => parts[3] ? parts[3].split('+') : undefined
    return { collection, tags, search, getTags }
  }
  static generateURL(tagFilters, navigate = true) {
    const { collection, search } = Sidebar.getRoute()

    const url = `/collections/${collection}/${tagFilters}${search}`
    const urlToLoad = `${url}`

    // Poner/Quitar PricingFilter
    // const pricingFilter = document.querySelector('#FacetsWrapperDesktop')
    // if(tagFilters == "") pricingFilter.classList.remove('hidden')
    // else pricingFilter.classList.add('hidden')

    // Cambiar URL
    if (navigate) history.pushState({}, null, url)
    return urlToLoad
  }
}

Sidebar.filterData = {}
customElements.define("side-bar", Sidebar)

class PseudoCheckbox extends HTMLElement {
  constructor() {
    super()
    console.log('Checkbox')
    this.addEventListener('custom_input', e => {
      this.classList.toggle('checked')
    },)
    const label = this.parentElement
    label.addEventListener('click', e => {
      this.check()
    })
    this.name = this.getAttribute('name')
    this.value = this.getAttribute('value')
  }
  check() {
    this.dispatchEvent(new CustomEvent("custom_input", { bubbles: true }))
  }
}
window.customElements.define('pseudo-checkbox', PseudoCheckbox)